<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SectionLayout from '../account/components/SectionLayout.vue';

const store = useStore();
const { t } = useI18n();
const saving = ref(false);
const enabled = computed(
  () => store.getters.getUISettings?.remember_last_conversation === true
);
const update = async event => {
  const value = event.target.checked;
  event.target.checked = enabled.value;
  if (saving.value) return;
  saving.value = true;
  try {
    await store.dispatch('updateProfile', {
      ui_settings: {
        ...store.getters.getUISettings,
        remember_last_conversation: value,
      },
    });
    useAlert(t('PROFILE_SETTINGS.CONVERSATION_PREFERENCES.SAVED'));
  } catch {
    useAlert(t('PROFILE_SETTINGS.CONVERSATION_PREFERENCES.ERROR'));
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <SectionLayout
    icon="i-lucide-history"
    class="!mt-0 rounded-2xl border border-n-weak bg-n-solid-1 !px-5 !py-6 sm:!px-6"
    :title="t('PROFILE_SETTINGS.CONVERSATION_PREFERENCES.TITLE')"
    :description="t('PROFILE_SETTINGS.CONVERSATION_PREFERENCES.DESCRIPTION')"
  >
    <label
      class="flex cursor-pointer items-start gap-3 text-sm text-n-slate-12"
    >
      <input
        type="checkbox"
        :checked="enabled"
        :disabled="saving"
        class="mt-0.5"
        @change="update"
      />
      <span>{{ t('PROFILE_SETTINGS.CONVERSATION_PREFERENCES.REMEMBER') }}</span>
    </label>
  </SectionLayout>
</template>
